module.exports = __webpack_public_path__ + "img/video.85f7988e.jpg";